<template>
  <card class="ad-banner">
    <h4 class="card-title">Banners</h4>
    <div class="banner-wrapper">
      <div
        class="banner-box"
        v-for="(adBanner, index) in adsBanners.slice(0, mas)"
        :key="index"
        @click="() => showImg(index)"
      >
        <img :src="adBanner.bannerURL" alt />
        <p>{{ adBanner.itemCode }}</p>
        <!--<p>{{ adBanner.SubscrId }}</p>-->
      </div>
      <vue-easy-lightbox
        :visible="visible"
        :imgs="images"
        @hide="handleHide"
        :index="index"
      ></vue-easy-lightbox>

      <div class="show-more1">
        <button v-on:click="collapse">
          <br />
          <button v-show="showMessage">Ver {{ mostrar }}</button>
          <!-- <font-awesome-icon icon="chevron-down" /> -->
        </button>
      </div>
    </div>
  </card>
</template>
<script>
export default {
  name: "ad-banners",
  props: {
    adsBanners: Array
  },
  data() {
    return {
      visible: false,
      index: 0,
      mas: 8,
      mostrar: "más +",
      showMessage: false
    };
  },
  created() {
    if (this.adsBanners.length > 8) {
      this.showMessage = true;
    }
  },
  computed: {
    images() {
      return this.adsBanners.map(image => image.bannerURL);
    }
  },
  methods: {
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    collapse() {
      if (this.mas == 8) {
        this.mas = this.adsBanners.length;
        this.mostrar = "menos -";
      } else if (this.mas > 9) {
        this.mas = 8;
        this.mostrar = "más +";
      }
    }
  }
};
</script>
<style lang="scss">
.ad-banner {
  h4 {
    margin-bottom: 15px;
  }
}
.banner-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  text-align: center;
  justify-content: center;
  position: relative;
  padding: 30px;
  &.collapsed {
    height: 355px;
    overflow: hidden;
    .show-more {
      display: block;
    }
  }
}

.show-more1 {
  position: absolute;
  bottom: 0;
  background: linear-gradient(0deg, #fff, #fff 70%, hsla(0, 0%, 100%, 0));
  color: $link-color;
  font-size: 12px;
  width: 100%;
  // display: none;
}

.banner-box {
  img {
    width: 120px;
    height: 120px;
    border-radius: 5px;
    border: 4px solid $primary-100;
    box-sizing: border-box;
    object-fit: cover;
  }
  p {
    font-size: 13px;
    margin-bottom: 0px;
    color: $neutral-gray-600;
    &:last-child {
      font-size: 11px;
      margin-top: -3px;
      color: $neutral-gray-300;
    }
  }
}
@include respond-above(md) {
  .banner-wrapper {
    grid-template-columns: repeat(4, 1fr);
    &.collapsed {
      height: 140px;
    }
  }
  .ad-banner {
    height: fit-content;
  }
  .banner-box {
    img {
      width: 80px;
      height: 80px;
    }
    p {
      font-size: 12px;
      line-height: 0.8rem;
      &:last-child {
        font-size: 10px;
        margin-top: 4px;
      }
    }
  }
}
</style>
